import dayjs from 'dayjs';

import { PerformanceResultsNotification } from 'pages/Campaign/PerformanceResults/api/usePerformanceResultsNotification/usePerformanceResultsNotification';

export const groupCampaignByChainId = (
  data?: PerformanceResultsNotification[],
): Record<string, PerformanceResultsNotification[]> => {
  let groupedData: Record<string, PerformanceResultsNotification[]> = {};
  const sortedData = [...(data ?? [])].sort((a, b) => {
    const valueA = a.endDate === 'Ongoing' ? Infinity : dayjs(a.endDate).format('YYYYMMDD');
    const valueB = b.endDate === 'Ongoing' ? Infinity : dayjs(b.endDate).format('YYYYMMDD');

    return Number(valueB) - Number(valueA);
  });
  sortedData.forEach((campaign) => {
    if (groupedData[campaign.chainId]) {
      groupedData[campaign.chainId].push(campaign);
    } else {
      groupedData[campaign.chainId] = [campaign];
    }
  });

  return groupedData;
};
